import styled from 'styled-components';

const Custom404Style = styled.div`
	padding-left: var(--contPaddingLR);
	padding-right: var(--contPaddingLR);
	height: 100dvh;
	/* height: 100%; */
	.error-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
		height: 100%;
	}

	.m-bottom {
		margin-bottom: 2.5rem;
	}

	.m-top {
		margin-top: 3rem;
	}

	.button-section {
		display: flex;
		justify-content: center;
	}
`;

export default Custom404Style;
